export const GET_ALL_COURSES_SUCCESS = 'GET_ALL_COURSES_SUCCESS';
export const LOADING_MESSAGE = 'Loading ...';
